import { jsx as r } from "react/jsx-runtime";
import f, { forwardRef as p, useImperativeHandle as L } from "react";
import { FixedSizeList as E } from "react-window";
import I from "./index.es5544.js";
import { BasicMenuItem as D } from "./index.es83.js";
import { useScreenZoom as O } from "./index.es589.js";
const T = 20, N = 10, d = 5, m = p(({ children: n, role: i, testId: e }, t) => /* @__PURE__ */ r("div", { "data-testid": e, ref: t, children: /* @__PURE__ */ r("div", { role: i, className: I.menuContainer, children: n }) })), Z = p(
  ({
    maxVisibleItems: n = d,
    children: i,
    itemCount: e,
    itemHeight: t,
    listWidth: M = "100%",
    NoResults: h,
    disabledVirtualization: o = !1,
    noWrapper: _,
    role: s = "menu",
    testId: a = "menu-list-container"
  }, S) => {
    const c = f.useRef(null);
    L(S, () => c.current, []);
    const l = O().zoomPercentage >= 250, v = f.useCallback(() => o ? e : l ? N : e <= n ? e : e > T ? d : Math.min(n, e), [o, l, e, n]), u = /* @__PURE__ */ r("div", { role: "presentation", children: /* @__PURE__ */ r(
      E,
      {
        ref: c,
        className: "List",
        height: t * v(),
        itemCount: e,
        itemSize: t,
        width: M,
        overscanCount: 5,
        "data-identifier": "virtualized-list-container",
        children: i
      }
    ) });
    return e === 0 ? /* @__PURE__ */ r(m, { role: s, testId: a, children: h || /* @__PURE__ */ r("div", { role: "menuitem", children: /* @__PURE__ */ r(
      D,
      {
        label: "No Search Results",
        value: "no-search-results-item-DS"
      }
    ) }) }) : _ ? u : /* @__PURE__ */ r(m, { role: s, testId: a, children: u });
  }
);
export {
  Z as MenuListContainer
};
//# sourceMappingURL=index.es88.js.map
